module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0112.png.d518cb1f.jpg";